import { ObterDeclIrSefModel } from './obterDeclIrSef.model';

export class DeclIrSefModel {

    constructor(
        public dataLiquidacao?: string,
        public vlLiquidacao?: number,
        public vlSaldoDevedor?: number,
        public vlPrestacoesNaoPagas?: number,
        public dtLanctoCompleta?: string,
        public vlTotGeral?: number,
        public vlTotPrest?: number,
        public vlTotAmort?: number,
        public isApresentaValor?: Boolean,
        public obterDeclIrSefDTO?: Array<ObterDeclIrSefModel>
    ) {
        this.obterDeclIrSefDTO = new Array<ObterDeclIrSefModel>();
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/declIrSef.model.ts